<template>
  <footer class="py-2">

    <div class="navbar px-3">
      <div class="col p-0">
        <ul class="list-inline mb-0" id="footer-nav">


          <li class="list-inline-item" v-html="$t('Footer.T&CLink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')">
          </li>
          <li class="list-inline-item"><a nohref="nohref" class="ot-sdk-show-settings" style="cursor:pointer;">Cookie
              Preferences</a></li>
          <li class="list-inline-item"><a rel="noopener noreferrer"
              href="https://www.kellanova.com/us/en/privacy-notice.html" target="_blank">Privacy&nbsp;Notice</a></li>
          <li class="list-inline-item"><a rel="noopener noreferrer"
              href="https://www.kellanova.com/us/en/us-privacy-notice.html" target="_blank">US&nbsp;Privacy</a></li>
          <li class="list-inline-item"><a rel="noopener noreferrer" href="https://www.kellanova.com/us/en/terms.html"
              target="_blank">Terms&nbsp;of&nbsp;Use</a></li>
          <li class="list-inline-item ypc"><a href="https://www.kellanova.com/us/en/do-not-sell-or-share.html"
              target="_blank">Your&nbsp;Privacy&nbsp;Choices</a></li>
          <li class="list-inline-item"><a rel="noopener noreferrer"
              href="https://www.kellanova.com/us/en/accessibility.html" target="_blank">Accessibility</a></li>

        </ul>
        <p class="mt-1 mb-0">
          <small>{{ $t('Footer.copyrighttext') }} © {{ new Date().getFullYear() }}
            {{ $t('Footer.AllrightReserved') }}</small>
        </p>

      </div>
      <div class="px-5">
        <div class="footer-social-nav">
          <ul class="list-inline m-0">
            <li>
              <a href="https://www.youtube.com/cheezit" class="yt-link social-icon" title="youtube" target="_blank">
                <i class="fab fa-youtube"></i>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/cheezit" class="ig-link social-icon" title="instagram" target="_blank">
                <i class="fab fa-instagram"></i>
              </a>
            </li>
            <li>
              <a href="https://www.tiktok.com/@cheezit?lang=en" class="tiktok-link social-icon" title="tiktok"
                target="_blank">
                <i class="fab fa-tiktok"></i>
              </a>
            </li>
            <li>
              <a href="https://x.com/cheezit" class="twitter-link social-icon" title="twitter" target="_blank">
                <i class="fab fa-x-twitter"></i>
              </a>
            </li>
          </ul>
        </div>

      </div>
    </div>


  </footer>
</template>
<!--
<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // Dynamically fetch the translated modelHash
    const modelHash = this.$t('YounetmodelHash');
    const modelImgurl = this.$t('YounetmodelIMg');
    const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;

    // Dynamically create the script element
    const script = document.createElement('script');
    script.type = 'module';
    script.src = scriptUrl;

    // Append the script to the body
    document.body.appendChild(script);
  },
};
</script>
-->
<style>
@media screen and (max-width: 575px) {
  .navbar {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #footer-nav li+li:before {
    content: '';
    margin-right: 0px;
  }

  footer {
    text-align: center;
  }

  footer li.list-inline-item {
    display: block;
  }

  footer li.list-inline-item {
    display: block;
  }

}
</style>

